import React from 'react';
import clsx from 'clsx';
import { exportToCSV } from 'components/Common/CSVManage';

interface IStep1Props {
  selectedTemp: string;
  handleTemplateSelect: any;
}

const Step1: React.FC<IStep1Props> = (props: IStep1Props) => {
  const { selectedTemp, handleTemplateSelect } = props;

  const genericHeaders = [
    'Unique Line Item',
    'Entity Name (Person / Company / Organization)',
    'Entity State',
    'Entity Country',
    'Commodity Name',
    'Commodity HTS Code',
  ];
  const expandedHeaders = [
    'Entry Summary Number',
    'Consignee Name',
    'Consignee Country',
    'Importer / Exporter Name',
    'Importer / Exporter Country',
    'Shipper Name',
    'Shipper Country',
    'Manufacturer Name',
    'Manufacturer Country',
    'Vessel Name',
    'Vessel Code',
    'Commodity Name',
    'Commodity HTS Code',
    'Brand Name',
    'Unloading Port',
    'Loading Port',
  ];

  return (
    <div className='template-container'>
      <div
        className={clsx('template-box', {
          ['template-selected']: selectedTemp === 'generic',
        })}
        onClick={() => handleTemplateSelect('generic')}
        id='generic'
      >
        <div
          className={clsx('template-checkbox', {
            ['checkbox-background']: selectedTemp === 'generic',
          })}
        >
          {selectedTemp === 'generic' ? (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='12'
              height='12'
              viewBox='0 0 12 12'
              fill='none'
            >
              <path
                d='M10 3L4.5 8.5L2 6'
                stroke='#DFEDFF'
                strokeWidth='1.6666'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          ) : (
            <></>
          )}
        </div>
        <div className='template-svg-background'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='19'
            height='19'
            viewBox='0 0 19 19'
            fill='none'
          >
            <path
              d='M15.6667 1.25H3.66666C3.06992 1.25 2.49762 1.48705 2.07567 1.90901C1.65371 2.33097 1.41666 2.90326 1.41666 3.5V15.5C1.41666 16.0967 1.65371 16.669 2.07567 17.091C2.49762 17.5129 3.06992 17.75 3.66666 17.75H15.6667C16.2634 17.75 16.8357 17.5129 17.2576 17.091C17.6796 16.669 17.9167 16.0967 17.9167 15.5V3.5C17.9167 2.90326 17.6796 2.33097 17.2576 1.90901C16.8357 1.48705 16.2634 1.25 15.6667 1.25ZM6.66666 16.25H3.66666C3.46774 16.25 3.27698 16.171 3.13633 16.0303C2.99567 15.8897 2.91666 15.6989 2.91666 15.5V14.615C3.15716 14.7023 3.4108 14.748 3.66666 14.75H6.66666V16.25ZM6.66666 13.25H3.66666C3.46774 13.25 3.27698 13.171 3.13633 13.0303C2.99567 12.8897 2.91666 12.6989 2.91666 12.5V11.615C3.15716 11.7023 3.4108 11.748 3.66666 11.75H6.66666V13.25ZM6.66666 10.25H3.66666C3.46774 10.25 3.27698 10.171 3.13633 10.0303C2.99567 9.88968 2.91666 9.69891 2.91666 9.5V3.5C2.91666 3.30109 2.99567 3.11032 3.13633 2.96967C3.27698 2.82902 3.46774 2.75 3.66666 2.75H6.66666V10.25ZM11.1667 16.25H8.16666V11.75H11.1667V16.25ZM11.1667 10.25H8.16666V2.75H11.1667V10.25ZM16.4167 15.5C16.4167 15.6989 16.3376 15.8897 16.197 16.0303C16.0563 16.171 15.8656 16.25 15.6667 16.25H12.6667V14.75H15.6667C15.9225 14.748 16.1762 14.7023 16.4167 14.615V15.5ZM16.4167 12.5C16.4167 12.6989 16.3376 12.8897 16.197 13.0303C16.0563 13.171 15.8656 13.25 15.6667 13.25H12.6667V11.75H15.6667C15.9225 11.748 16.1762 11.7023 16.4167 11.615V12.5ZM16.4167 9.5C16.4167 9.69891 16.3376 9.88968 16.197 10.0303C16.0563 10.171 15.8656 10.25 15.6667 10.25H12.6667V2.75H15.6667C15.8656 2.75 16.0563 2.82902 16.197 2.96967C16.3376 3.11032 16.4167 3.30109 16.4167 3.5V9.5ZM14.1667 5.75C14.0183 5.75 13.8733 5.79399 13.75 5.8764C13.6266 5.95881 13.5305 6.07594 13.4737 6.21299C13.417 6.35003 13.4021 6.50083 13.4311 6.64632C13.46 6.7918 13.5314 6.92544 13.6363 7.03033C13.7412 7.13522 13.8749 7.20665 14.0203 7.23559C14.1658 7.26453 14.3166 7.24968 14.4537 7.19291C14.5907 7.13614 14.7078 7.04001 14.7903 6.91668C14.8727 6.79334 14.9167 6.64834 14.9167 6.5C14.9167 6.30109 14.8376 6.11032 14.697 5.96967C14.5563 5.82902 14.3656 5.75 14.1667 5.75ZM5.16666 7.25C5.31499 7.25 5.46 7.20601 5.58333 7.1236C5.70667 7.04119 5.8028 6.92406 5.85957 6.78701C5.91633 6.64997 5.93118 6.49917 5.90225 6.35368C5.87331 6.2082 5.80188 6.07456 5.69699 5.96967C5.5921 5.86478 5.45846 5.79335 5.31297 5.76441C5.16749 5.73547 5.01669 5.75032 4.87964 5.80709C4.7426 5.86386 4.62547 5.95999 4.54305 6.08332C4.46064 6.20666 4.41666 6.35166 4.41666 6.5C4.41666 6.69891 4.49567 6.88968 4.63633 7.03033C4.77698 7.17098 4.96774 7.25 5.16666 7.25Z'
              fill='var(--text-primary)'
            />
          </svg>
        </div>
        <h6>Generic</h6>
        <p>
          Data entry for general information regarding an entity or commodity.
        </p>
        <div
          className='template-btn'
          onClick={() =>
            exportToCSV('generic-template.csv', [], genericHeaders)
          }
        >
          <h5>Download</h5>
        </div>
      </div>
      <div
        className={clsx('template-box', 'template-spacer', {
          ['template-selected']: selectedTemp === 'import',
        })}
        onClick={() => handleTemplateSelect('import')}
        id='import'
      >
        <div
          className={clsx('template-checkbox', {
            ['checkbox-background']: selectedTemp === 'import',
          })}
        >
          {selectedTemp === 'import' ? (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='12'
              height='12'
              viewBox='0 0 12 12'
              fill='none'
            >
              <path
                d='M10 3L4.5 8.5L2 6'
                stroke='#DFEDFF'
                strokeWidth='1.6666'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          ) : (
            <></>
          )}
        </div>
        <div className='template-svg-background'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='19'
            height='19'
            viewBox='0 0 19 19'
            fill='none'
          >
            <path
              d='M15.6667 1.25H3.66666C3.06992 1.25 2.49762 1.48705 2.07567 1.90901C1.65371 2.33097 1.41666 2.90326 1.41666 3.5V15.5C1.41666 16.0967 1.65371 16.669 2.07567 17.091C2.49762 17.5129 3.06992 17.75 3.66666 17.75H15.6667C16.2634 17.75 16.8357 17.5129 17.2576 17.091C17.6796 16.669 17.9167 16.0967 17.9167 15.5V3.5C17.9167 2.90326 17.6796 2.33097 17.2576 1.90901C16.8357 1.48705 16.2634 1.25 15.6667 1.25ZM6.66666 16.25H3.66666C3.46774 16.25 3.27698 16.171 3.13633 16.0303C2.99567 15.8897 2.91666 15.6989 2.91666 15.5V14.615C3.15716 14.7023 3.4108 14.748 3.66666 14.75H6.66666V16.25ZM6.66666 13.25H3.66666C3.46774 13.25 3.27698 13.171 3.13633 13.0303C2.99567 12.8897 2.91666 12.6989 2.91666 12.5V11.615C3.15716 11.7023 3.4108 11.748 3.66666 11.75H6.66666V13.25ZM6.66666 10.25H3.66666C3.46774 10.25 3.27698 10.171 3.13633 10.0303C2.99567 9.88968 2.91666 9.69891 2.91666 9.5V3.5C2.91666 3.30109 2.99567 3.11032 3.13633 2.96967C3.27698 2.82902 3.46774 2.75 3.66666 2.75H6.66666V10.25ZM11.1667 16.25H8.16666V11.75H11.1667V16.25ZM11.1667 10.25H8.16666V2.75H11.1667V10.25ZM16.4167 15.5C16.4167 15.6989 16.3376 15.8897 16.197 16.0303C16.0563 16.171 15.8656 16.25 15.6667 16.25H12.6667V14.75H15.6667C15.9225 14.748 16.1762 14.7023 16.4167 14.615V15.5ZM16.4167 12.5C16.4167 12.6989 16.3376 12.8897 16.197 13.0303C16.0563 13.171 15.8656 13.25 15.6667 13.25H12.6667V11.75H15.6667C15.9225 11.748 16.1762 11.7023 16.4167 11.615V12.5ZM16.4167 9.5C16.4167 9.69891 16.3376 9.88968 16.197 10.0303C16.0563 10.171 15.8656 10.25 15.6667 10.25H12.6667V2.75H15.6667C15.8656 2.75 16.0563 2.82902 16.197 2.96967C16.3376 3.11032 16.4167 3.30109 16.4167 3.5V9.5ZM14.1667 5.75C14.0183 5.75 13.8733 5.79399 13.75 5.8764C13.6266 5.95881 13.5305 6.07594 13.4737 6.21299C13.417 6.35003 13.4021 6.50083 13.4311 6.64632C13.46 6.7918 13.5314 6.92544 13.6363 7.03033C13.7412 7.13522 13.8749 7.20665 14.0203 7.23559C14.1658 7.26453 14.3166 7.24968 14.4537 7.19291C14.5907 7.13614 14.7078 7.04001 14.7903 6.91668C14.8727 6.79334 14.9167 6.64834 14.9167 6.5C14.9167 6.30109 14.8376 6.11032 14.697 5.96967C14.5563 5.82902 14.3656 5.75 14.1667 5.75ZM5.16666 7.25C5.31499 7.25 5.46 7.20601 5.58333 7.1236C5.70667 7.04119 5.8028 6.92406 5.85957 6.78701C5.91633 6.64997 5.93118 6.49917 5.90225 6.35368C5.87331 6.2082 5.80188 6.07456 5.69699 5.96967C5.5921 5.86478 5.45846 5.79335 5.31297 5.76441C5.16749 5.73547 5.01669 5.75032 4.87964 5.80709C4.7426 5.86386 4.62547 5.95999 4.54305 6.08332C4.46064 6.20666 4.41666 6.35166 4.41666 6.5C4.41666 6.69891 4.49567 6.88968 4.63633 7.03033C4.77698 7.17098 4.96774 7.25 5.16666 7.25Z'
              fill='var(--text-primary)'
            />
          </svg>
        </div>
        <h6>Import/Export</h6>
        <p>
          Data entry for specific information regarding imports and exports.
        </p>
        <div
          className='template-btn'
          onClick={() =>
            exportToCSV('import-export-template.csv', [], expandedHeaders)
          }
        >
          <h5>Download</h5>
        </div>
      </div>
      <div
        className={clsx('template-box', {
          ['template-selected']: selectedTemp === 'custom',
        })}
        onClick={() => handleTemplateSelect('custom')}
        id='custom'
      >
        <div
          className={clsx('template-checkbox', {
            ['checkbox-background']: selectedTemp === 'custom',
          })}
        >
          {selectedTemp === 'custom' ? (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='12'
              height='12'
              viewBox='0 0 12 12'
              fill='none'
            >
              <path
                d='M10 3L4.5 8.5L2 6'
                stroke='#DFEDFF'
                strokeWidth='1.6666'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          ) : (
            <></>
          )}
        </div>
        <div className='template-svg-background'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='19'
            height='19'
            viewBox='0 0 19 19'
            fill='none'
          >
            <path
              d='M15.6667 1.25H3.66666C3.06992 1.25 2.49762 1.48705 2.07567 1.90901C1.65371 2.33097 1.41666 2.90326 1.41666 3.5V15.5C1.41666 16.0967 1.65371 16.669 2.07567 17.091C2.49762 17.5129 3.06992 17.75 3.66666 17.75H15.6667C16.2634 17.75 16.8357 17.5129 17.2576 17.091C17.6796 16.669 17.9167 16.0967 17.9167 15.5V3.5C17.9167 2.90326 17.6796 2.33097 17.2576 1.90901C16.8357 1.48705 16.2634 1.25 15.6667 1.25ZM6.66666 16.25H3.66666C3.46774 16.25 3.27698 16.171 3.13633 16.0303C2.99567 15.8897 2.91666 15.6989 2.91666 15.5V14.615C3.15716 14.7023 3.4108 14.748 3.66666 14.75H6.66666V16.25ZM6.66666 13.25H3.66666C3.46774 13.25 3.27698 13.171 3.13633 13.0303C2.99567 12.8897 2.91666 12.6989 2.91666 12.5V11.615C3.15716 11.7023 3.4108 11.748 3.66666 11.75H6.66666V13.25ZM6.66666 10.25H3.66666C3.46774 10.25 3.27698 10.171 3.13633 10.0303C2.99567 9.88968 2.91666 9.69891 2.91666 9.5V3.5C2.91666 3.30109 2.99567 3.11032 3.13633 2.96967C3.27698 2.82902 3.46774 2.75 3.66666 2.75H6.66666V10.25ZM11.1667 16.25H8.16666V11.75H11.1667V16.25ZM11.1667 10.25H8.16666V2.75H11.1667V10.25ZM16.4167 15.5C16.4167 15.6989 16.3376 15.8897 16.197 16.0303C16.0563 16.171 15.8656 16.25 15.6667 16.25H12.6667V14.75H15.6667C15.9225 14.748 16.1762 14.7023 16.4167 14.615V15.5ZM16.4167 12.5C16.4167 12.6989 16.3376 12.8897 16.197 13.0303C16.0563 13.171 15.8656 13.25 15.6667 13.25H12.6667V11.75H15.6667C15.9225 11.748 16.1762 11.7023 16.4167 11.615V12.5ZM16.4167 9.5C16.4167 9.69891 16.3376 9.88968 16.197 10.0303C16.0563 10.171 15.8656 10.25 15.6667 10.25H12.6667V2.75H15.6667C15.8656 2.75 16.0563 2.82902 16.197 2.96967C16.3376 3.11032 16.4167 3.30109 16.4167 3.5V9.5ZM14.1667 5.75C14.0183 5.75 13.8733 5.79399 13.75 5.8764C13.6266 5.95881 13.5305 6.07594 13.4737 6.21299C13.417 6.35003 13.4021 6.50083 13.4311 6.64632C13.46 6.7918 13.5314 6.92544 13.6363 7.03033C13.7412 7.13522 13.8749 7.20665 14.0203 7.23559C14.1658 7.26453 14.3166 7.24968 14.4537 7.19291C14.5907 7.13614 14.7078 7.04001 14.7903 6.91668C14.8727 6.79334 14.9167 6.64834 14.9167 6.5C14.9167 6.30109 14.8376 6.11032 14.697 5.96967C14.5563 5.82902 14.3656 5.75 14.1667 5.75ZM5.16666 7.25C5.31499 7.25 5.46 7.20601 5.58333 7.1236C5.70667 7.04119 5.8028 6.92406 5.85957 6.78701C5.91633 6.64997 5.93118 6.49917 5.90225 6.35368C5.87331 6.2082 5.80188 6.07456 5.69699 5.96967C5.5921 5.86478 5.45846 5.79335 5.31297 5.76441C5.16749 5.73547 5.01669 5.75032 4.87964 5.80709C4.7426 5.86386 4.62547 5.95999 4.54305 6.08332C4.46064 6.20666 4.41666 6.35166 4.41666 6.5C4.41666 6.69891 4.49567 6.88968 4.63633 7.03033C4.77698 7.17098 4.96774 7.25 5.16666 7.25Z'
              fill='var(--text-primary)'
            />
          </svg>
        </div>
        <h6>Custom</h6>
        <p>Select this if you are uploading your own file with custom data.</p>
        <div className='template-btn-spacer'>
          <h5>Ensure Document has Column Headers</h5>
        </div>
      </div>
    </div>
  );
};

export default Step1;
